import type { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import ImageButton from './ImageButton.View';
import type {
	DispatchProps as ImageButtonDispatchProps,
	OwnProps as ImageButtonOwnProps,
	StateProps as ImageButtonStateProps
} from './ImageButton.View';
import Assets from '../../assets/Assets';

const Content = styled.div`
	align-items: center;
	bottom: 0;
	color: ${(props) => props.theme.colors.darkBlue};
	display: flex;
	font: ${(props) => props.theme.font.button};
	font-size: 3vmin;
	justify-content: center;
	left: 0;
	position: absolute;
	right: 0;
	text-overflow: ellipsis;
	top: 0;
	margin-left: 40%;
	margin-right: 10%;
`;

export type StateProps = ImageButtonStateProps;
export type DispatchProps = ImageButtonDispatchProps;
export type OwnProps = Omit<
	ImageButtonOwnProps,
	'src' | 'shadow' | 'width' | 'height'
>;

export type Props = StateProps & DispatchProps & OwnProps;

const BackButton: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => {
	const { children, ...otherProps } = props;

	return (
		<ImageButton
			src={Assets.images.back}
			width="32vmin"
			height="19vmin"
			shadow
			{...otherProps}
		>
			<Content>{children}</Content>
		</ImageButton>
	);
};

export default BackButton;
